const parseColor = (theme, colorString, defaultVariant) => {
  if (typeof colorString === 'undefined') return 'currentColor';
  if (
    colorString.toLowerCase() === 'currentcolor'
    || /^#[a-zA-Z0-9]{3,8}$/.test(colorString) // #000 #aabbcc #aabbcc00
    || /^[a-z-]+\(.+\)$/.test(colorString) // func-name(...)
  ) {
    return colorString;
  }
  const [color = 'primary', variant = defaultVariant] = colorString.split('.');
  return theme.palette?.[color]?.[variant || 'main'];
};

export default parseColor;
